<!--
 * @Description: 文件内容描述
 * @Author: 编辑人
 * @Date: 2021-11-03 10:20:13
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>
<style>
/* @import url('@/assets/css/icons/iconfont.css'); */
</style>
<style lang="scss" scoped>
#app {
  font-family: 'sourcehansans';
}
</style>

